import store from '@/store';
import { CurrencyConfig } from '@/store/models';

const configs: CurrencyConfig = {
    decimalCount: store.state.options.currency.decimals,
    decimalSeparator: store.state.options.currency.decimals_separator,
    thousandsSeparator: store.state.options.currency.thousands_separator,
    sign: store.state.options.currency.symbol,
    signPosition: store.state.options.currency.signpos,
    code: store.state.options.currency.code,
};

function format(amount: any) {
    try {
        const decimalCount = configs.decimalCount ? Math.abs(configs.decimalCount) : 2;
        const negativeSign = amount < 0 ? '-' : '';

        const [integerPart, decimalPart] = Math.abs(Number(amount) || 0)
            .toFixed(3)
            .split('.');

        const truncatedDecimal = decimalPart.slice(0, decimalCount);
        const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, `${configs.thousandsSeparator}`);

        const formattedValue = `${negativeSign}${formattedInteger}${configs.decimalSeparator}${truncatedDecimal}`;

        switch (configs.signPosition) {
            case 'after':
                return `${formattedValue} ${configs.sign}`;
            case 'before':
                return `${configs.sign} ${formattedValue}`;
            default:
                throw Error('Sign position not supported');
        }
    } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
        return '';
    }
}

export default (value: any) => {
    return format(value);
};
